// src/pages/UsuariosNovo.jsx
import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Grid, TextField, MenuItem, FormControlLabel, Checkbox,
  Button, Paper
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../services/api';

function dataHojeSP() {
  const hojeSP = new Date(
    new Date().toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' })
  );
  const ano = hojeSP.getFullYear();
  const mes = String(hojeSP.getMonth() + 1).padStart(2, '0');
  const dia = String(hojeSP.getDate()).padStart(2, '0');
  return `${ano}-${mes}-${dia}`;
}

function UsuariosNovo() {
  const navigate = useNavigate();
  const { id } = useParams();
  const editando = !!id;
  const hoje = dataHojeSP();

  const formInicial = {
    chave: '',
    nome: '',
    email: '',
    telefone: '',
    data_cadastro: hoje,
    data_renovacao: '',
    data_vencimento: '',
    qt_dias: '',
    tipo: 'revendedor',
    pode_usar_kit_blindagem: false,
    creditos_kit_blindagem: 0,
    pode_usar_webhook: false,
    senha: '',
    link_drive_downloads: '',
    link_whatsapp: '',
    anotacao: '',
    status: 'ativo',
    criado_em: hoje,
  };

  const [form, setForm] = useState(formInicial);
  const [formAlterado, setFormAlterado] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === 'qt_dias') {
      if (value === '' || value === null) {
        setForm((prev) => ({
          ...prev,
          qt_dias: '',
          data_vencimento: prev.data_vencimento,
        }));
        setFormAlterado(true);
        return;
      }
      let dias = Math.max(1, Math.min(Number(value), 1000));
      const base = form.data_renovacao ? new Date(form.data_renovacao) : new Date();
      base.setDate(base.getDate() + dias);
      setForm((prev) => ({
        ...prev,
        qt_dias: dias,
        data_vencimento: base.toISOString().split('T')[0],
      }));
      setFormAlterado(true);
      return;
    }

    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
    setFormAlterado(true);
  };

  const validate = () => {
    let tempErrors = {};
    if (!form.nome) tempErrors.nome = 'Obrigatório';
    if (!form.email) tempErrors.email = 'Obrigatório';
    if (!form.data_vencimento) tempErrors.data_vencimento = 'Obrigatório';
    if (!form.tipo) tempErrors.tipo = 'Obrigatório';
    if (!editando && !form.senha) tempErrors.senha = 'Obrigatório';
    return Object.keys(tempErrors).length === 0;
  };

  const carregarUsuario = async () => {
    try {
      const response = await api.get(`/usuarios/${id}`);
      const dados = response.data;
      setForm({
        chave: dados.chave || '',
        nome: dados.nome,
        email: dados.email,
        telefone: dados.telefone || '',
        data_renovacao: dados.data_renovacao ? dados.data_renovacao.split('T')[0] : '',
        data_vencimento: dados.data_vencimento ? dados.data_vencimento.split('T')[0] : '',
        qt_dias: '',
        tipo: dados.tipo,
        pode_usar_kit_blindagem: dados.pode_usar_kit_blindagem === 1,
        creditos_kit_blindagem: Number(dados.creditos_kit_blindagem || 0),
        pode_usar_webhook: dados.pode_usar_webhook === 1,
        senha: '',
        link_drive_downloads: dados.link_drive_downloads || '',
        link_whatsapp: dados.link_whatsapp || '',
        anotacao: dados.anotacao || '',
        status: dados.status,
        data_cadastro: dados.criado_em ? dados.criado_em.split('T')[0] : hoje,
        criado_em: dados.criado_em ? dados.criado_em.split('T')[0] : hoje,
      });
    } catch (err) {
      alert('Erro ao carregar usuário.');
      navigate('/usuarios');
    }
  };

  useEffect(() => {
    if (editando) carregarUsuario();
    // eslint-disable-next-line
  }, [id]);

  const handleSubmit = async () => {
    if (!validate()) return;
    try {
      const payload = {
        nome: form.nome,
        email: form.email,
        telefone: form.telefone.trim() !== '' ? form.telefone : null,
        tipo: form.tipo,
        pode_usar_kit_blindagem: form.pode_usar_kit_blindagem ? 1 : 0,
        creditos_kit_blindagem:
          form.creditos_kit_blindagem === '' || form.creditos_kit_blindagem == null
            ? 0
            : Number(form.creditos_kit_blindagem),
        pode_usar_webhook: form.pode_usar_webhook ? 1 : 0,
        data_renovacao: form.data_renovacao.trim() !== '' ? form.data_renovacao : null,
        data_vencimento: form.data_vencimento.trim() !== '' ? form.data_vencimento : null,
        status: form.status,
        link_drive_downloads:
          form.link_drive_downloads.trim() !== '' ? form.link_drive_downloads : null,
        link_whatsapp:
          form.link_whatsapp.trim() !== '' ? form.link_whatsapp : null,
        anotacao: form.anotacao.trim() !== '' ? form.anotacao.trim() : null,
        senha: form.senha,
      };

      if (editando) {
        await api.put(`/usuarios/${id}`, payload);
        alert('Usuário atualizado com sucesso!');
      } else {
        await api.post('/usuarios', payload);
        alert('Usuário cadastrado com sucesso!');
      }
      navigate('/usuarios');
    } catch (err) {
      const msgErroBackend =
        err.response?.data?.error ||
        'Erro ao salvar usuário. Verifique os campos e tente novamente.';
      alert(msgErroBackend);
    }
  };

  const handleCancel = () => {
    if (formAlterado) {
      if (!window.confirm('Você tem certeza que deseja sair? Alterações não salvas serão perdidas.')) return;
    }
    navigate('/usuarios');
  };

  return (
    <Box p={4}>
      <Typography variant="h4" mb={3}>
        {id ? 'Editar Usuário' : 'Cadastrar Novo Usuário'}
      </Typography>

      <Paper sx={{ p: 3 }}>
        <Grid container spacing={3}>
          {/* ESQUERDA: campos "pequenos" (igual Licença) */}
          <Grid item xs={12} md={7}>
            {/* Status e Tipo */}
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
              Status e Tipo
            </Typography>
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Status"
                  name="status"
                  value={form.status}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                >
                  <MenuItem value="ativo">Ativo</MenuItem>
                  <MenuItem value="inativo">Inativo</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Tipo de Usuário"
                  name="tipo"
                  value={form.tipo}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                >
                  <MenuItem value="admin">Admin</MenuItem>
                  <MenuItem value="revendedor">Revendedor</MenuItem>
                </TextField>
              </Grid>
            </Grid>


            {/* Permissões Especiais */}
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
              Permissões Especiais
            </Typography>

            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="pode_usar_kit_blindagem"
                      checked={!!form.pode_usar_kit_blindagem}
                      onChange={handleChange}
                      size="small"
                    />
                  }
                  label="Pode usar Kit Blindagem?"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="pode_usar_webhook"
                      checked={!!form.pode_usar_webhook}
                      onChange={handleChange}
                      size="small"
                    />
                  }
                  label="Pode usar Webhook?"
                />
              </Grid>
            </Grid>

            {/* Créditos Kit Blindagem */}
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
              Créditos Kit Blindagem
            </Typography>

            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Créditos Kit Blindagem"
                  name="creditos_kit_blindagem"
                  type="number"
                  value={form.creditos_kit_blindagem}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  inputProps={{ min: 0 }}
                  helperText="Quantidade de créditos que o revendedor pode usar para baixar pendência no Kit Blindagem."
                />
              </Grid>
            </Grid>

            {/* Dados Pessoais */}
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
              Dados Pessoais
            </Typography>
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Nome"
                  name="nome"
                  value={form.nome}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Telefone"
                  name="telefone"
                  value={form.telefone}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Senha"
                  name="senha"
                  type="password"
                  value={form.senha}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  helperText="Preencha apenas se quiser alterar a senha"
                />
              </Grid>
            </Grid>

            {/* Datas */}
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
              Datas
            </Typography>
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Data de Cadastro"
                  type="date"
                  name="data_cadastro"
                  value={form.data_cadastro}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Data de Renovação"
                  type="date"
                  name="data_renovacao"
                  value={form.data_renovacao}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Data de Vencimento"
                  type="date"
                  name="data_vencimento"
                  value={form.data_vencimento}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Qt Dias"
                  name="qt_dias"
                  value={form.qt_dias}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                />
              </Grid>
            </Grid>

            {/* Links */}
            <Typography variant="subtitle1" sx={{ mt: 3, mb: 1 }}>
              Links
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Link Drive Downloads"
                  name="link_drive_downloads"
                  fullWidth
                  size="small"
                  value={form.link_drive_downloads}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  label="Link WhatsApp"
                  name="link_whatsapp"
                  fullWidth
                  size="small"
                  value={form.link_whatsapp}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* DIREITA: bloco grande de anotação */}
          <Grid item xs={12} md={5}>
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
              Anotação (Representante / Administrativa)
            </Typography>
            <TextField
              name="anotacao"
              value={form.anotacao}
              onChange={handleChange}
              multiline
              minRows={24}
              fullWidth
              placeholder="Use este campo para observações gerais, histórico, etc."
            />
          </Grid>
        </Grid>

        <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="outlined" onClick={handleCancel}>
            Voltar
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            Salvar
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}

export default UsuariosNovo;
